import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getLanguageByCode } from '../config/languages.js';
import { stripLangPrefix } from '../utils/localizedPath.js';

// Single source of truth for "URL -> active i18n language": on every
// navigation (including back/forward), derives the language from
// location.pathname and syncs i18next + <html lang>. Renders nothing.
const LanguageSync = () => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const { lang } = stripLangPrefix(location.pathname);

  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  useEffect(() => {
    document.documentElement.lang = getLanguageByCode(lang)?.htmlLang ?? 'en';
  }, [lang]);

  return null;
};

export default LanguageSync;
